import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environment/environment";
import { SaveTariffRatesRequestVM, TariffRateVM } from "@models/backend-generated-models/models";
import { Observable } from "rxjs";

/**
 * Saving the rates a client enters in the what-if. They are read back with the chart's own data, so
 * there is no separate load.
 *
 * Errors are left to the caller rather than routed through the global handler: a refused set comes
 * back with a sentence saying what is wrong with it ("Add a day rate..."), and the panel shows that
 * beside the rates instead of in a toast.
 */
@Injectable({ providedIn: 'root' })
export class TariffService {
    constructor(private httpClient: HttpClient) {}

    saveRates$(siteId: number, rates: TariffRateVM[]): Observable<TariffRateVM[]> {
        const body: SaveTariffRatesRequestVM = { siteId, rates };
        return this.httpClient.put<TariffRateVM[]>(`${environment.apiUrl}tariff/rates`, body);
    }
}
